import { render, staticRenderFns } from "./erweimaShare.vue?vue&type=template&id=87b0a5ae&scoped=true&"
import script from "./erweimaShare.vue?vue&type=script&lang=js&"
export * from "./erweimaShare.vue?vue&type=script&lang=js&"
import style0 from "./erweimaShare.vue?vue&type=style&index=0&id=87b0a5ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b0a5ae",
  null
  
)

export default component.exports